// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2369":"dc55e599","2706":"dc55e599","5108":"dc55e599","5670":"6ec05308"}[chunkId] + ".chunk.css";
};